import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updatePopupVisibility } from './../../actions/FormationActions';
import common from './../../common';

class FormationLabel extends Component {
    showHidePopup = () => {
        // common.customTracking('Formation');
        this.props.updatePopupVisibility();
    };

    render() {
        let defaultFormation = this.props.defaultFormation;
        if (Object.keys(defaultFormation).length) {
            let fwd = defaultFormation.FWD;
            let mid = defaultFormation.MID;
            let def = defaultFormation.DEF;
            let formationStr = def + '-' + mid + '-' + fwd;
            return <div className="si-formation-btn si-flexBox" onClick={ () => this.showHidePopup() }>
                <span className="si-formation-type">{ formationStr }</span>
                <i className="icon-ucl-arrow_down" />
            </div>
        }
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        defaultFormation: state.formationData.defaultFormation,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updatePopupVisibility: () => dispatch(updatePopupVisibility()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormationLabel);


// WEBPACK FOOTER //
// ./src/components/onboarding/FormationLabel.js